import React, { useState } from "react";

type Props = {
  title: any;
  icon?: any;
  desc?: string;
  classname?: string;
  whiteIcon?: any;
};

export default function SectioncardserviceIndustry({
  title,
  icon,
  desc,
  classname,
  whiteIcon,
}: Props) {
  const [enter, setEnter] = useState(false);
  const MouseEnter = () => {
    setEnter(true);
  };
  const MouseLeave = () => {
    setEnter(false);
  };
  const textsize = enter
    ? "d-flex text-white font-16 fonts-800 line-18 px-20 pt-10 justify-content-center align-items-center"
    : "d-flex dark-header justify-content-center align-items-center font-24 fonts-800 line-28 pt-1";
  const imgsize = enter ? "w-40 mt-20" : "w-40 mt-30";
  return (
    <>
      <div
        className={`${classname} card-border landing-cards text-center`}
        onMouseEnter={MouseEnter}
        onMouseLeave={MouseLeave}
      >
        <img
          className={`${imgsize} pb-10`}
          src={enter ? whiteIcon : icon}
          alt={icon}
        />

        <p
          className={`${textsize} font-family-roboto-flex pb-10 text-center px-30`}
        >
          {title}
        </p>
        {desc && (
          <p className="text-white font-13 px-10 font-family-roboto fonts-400 line-15">
            {enter ? desc : ""}
          </p>
        )}
      </div>
    </>
  );
}
